import React, { lazy, Suspense } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Progress } from '@prima-afp/prima-ui-elements/dist/core';
import { withStepsHOC, withGuardHOC } from '../hocs';
import { PersistentProvider, AppGlobalComponents } from './Wrappers';
import ROUTES from './routes';

const HomePage = lazy(() => import('../pages/HomePage'));
const DocumentVerificationPage = lazy(() => import('../pages/DocumentVerificationPage'));
const BeneficiariesRegisterPage = lazy(() => import('../pages/BeneficiariesRegisterPage'));
const MinimumPensionEstimatePage = lazy(() => import('../pages/MinimumPensionEstimatePage'));
const ErrorPage = lazy(() => import('../pages/ErrorPage'));

const MinimumPensionEstimatorModuleRouter = () => {

  return (
    <PersistentProvider>
        <AppGlobalComponents>
          <Suspense fallback={ <Progress showMessages={ false } /> }>
            <Switch>
              <Route exact path={ROUTES.HOME} component={ HomePage } />
              <Route exact path={ROUTES.DOCUMENT_VERIFICATION} component={ DocumentVerificationPage } />
              <Route exact path={ROUTES.BENEFICIARIES_REGISTER} component={ withGuardHOC(withStepsHOC(BeneficiariesRegisterPage)) } />
              <Route exact path={ROUTES.MINIMUM_PENSION_ESTIMATE} component={ withGuardHOC(withStepsHOC(MinimumPensionEstimatePage)) } />
              <Route exact path={ROUTES.ERROR} component={ ErrorPage } />
              <Redirect to={ROUTES.HOME} />
            </Switch>
          </Suspense>
        </AppGlobalComponents>
    </PersistentProvider>
  );
};

export default MinimumPensionEstimatorModuleRouter;
